import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { formatDate } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Colors } from "../../../constants/styles";
import { Loader, SearchBar } from "../../../components";
import {
  Box,
  Typography,
  TextField,
  Button,
  Divider,
  Snackbar,
  Alert,
  Paper,
  Dialog,
  DialogTitle,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SaveIcon from "@mui/icons-material/Save";
import { makeStyles } from "@mui/styles";
import { Col, Row, Form } from "react-bootstrap";
import { NumericFormat } from "react-number-format";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const TambahRst = ({ rstKe }) => {
  const { user, dispatch } = useContext(AuthContext);
  const { screenSize } = useStateContext();
  const navigate = useNavigate();
  const classes = useStyles();

  const [validated, setValidated] = useState(false);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openJual, setOpenJual] = useState(false);

  const [juals, setJuals] = useState([]);
  const [searchTermJual, setSearchTermJual] = useState("");
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(0);
  const [limit] = useState(10);
  const [pages, setPages] = useState(0);

  const [jualId, setJualId] = useState("");
  const [parentId, setParentId] = useState("");
  const [noJual, setNoJual] = useState("");

  const [noKtpRegister, setNoKtpRegister] = useState("");
  const [namaRegister, setNamaRegister] = useState("");
  const [almRegister, setAlmRegister] = useState("");
  const [kodeKelurahan, setKodeKelurahan] = useState("");
  const [tanggalJual, setTanggalJual] = useState("");
  const [kodeSurveyor, setKodeSurveyor] = useState("");
  const [kodeMarketing, setKodeMarketing] = useState("");

  const [tipe, setTipe] = useState("");
  const [noMesin, setNoMesin] = useState("");
  const [namaWarna, setNamaWarna] = useState("");
  const [tahun, setTahun] = useState("");

  const [noAngsuran, setNoAngsuran] = useState("");
  const [dari, setDari] = useState("");
  const [tglJatuhTempoFormatted, setTglJatuhTempoFormatted] = useState("");
  const [tenorLama, setTenorLama] = useState("");
  const [sisaLama, setSisaLama] = useState("");
  const [angPerBulanLama, setAngPerBulanLama] = useState("");
  const [tglAngLama, setTglAngLama] = useState("");
  const [sisaPokokLama, setSisaPokokLama] = useState("");
  const [tglRst, setTglRst] = useState(new Date());
  const [tenorBaru, setTenorBaru] = useState("");
  const [tglAngAwal, setTglAngAwal] = useState(null);
  const [tglAngAkhir, setTglAngAkhir] = useState(null);
  const [angPerBulan, setAngPerBulan] = useState("");
  const [totalPiutang, setTotalPiutang] = useState(0);

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const title = `Entry RST ${rstKe}`;
  const textRst = `RST ${rstKe}`;

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleClickOpenJual = () => {
    setOpenJual(true);
  };

  const handleCloseJual = () => {
    setOpenJual(false);
  };

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTermJual(query);
  };

  const addMonths = (date, months) => {
    let tempDate = new Date(date);
    let d = tempDate.getDate();
    tempDate.setMonth(tempDate.getMonth() + +months - 1);
    if (tempDate.getDate() !== d) {
      tempDate.setDate(0);
    }
    return tempDate;
  };

  const toApiDate = (date) => {
    if (!date) {
      return "";
    }

    return (
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1).toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      "-" +
      date.getDate().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })
    );
  };

  const formatNumber = (value) => {
    const numberValue = Math.round(Number(value || 0));
    return numberValue ? numberValue.toLocaleString("en-US") : "";
  };

  useEffect(() => {
    getJual();
  }, [page, searchTermJual]);

  useEffect(() => {
    const tenorNumber = Number(tenorBaru);
    const angPerBulanNumber = Number(String(angPerBulan).replace(/,/g, ""));

    if (tglAngAwal && tenorNumber > 0) {
      setTglAngAkhir(addMonths(tglAngAwal, tenorNumber));
    } else {
      setTglAngAkhir(null);
    }

    if (tenorNumber > 0 && angPerBulanNumber > 0) {
      setTotalPiutang(tenorNumber * angPerBulanNumber);
    } else {
      setTotalPiutang(0);
    }
  }, [tenorBaru, tglAngAwal, angPerBulan]);

  const getJual = async () => {
    const allJualsForAngsuran = await axios.post(
      `${tempUrl}/jualsForAngsuranPagination?search_query=${searchTermJual}&page=${page}&limit=${limit}`,
      {
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      }
    );
    setJuals(allJualsForAngsuran.data.juals);
    setPage(allJualsForAngsuran.data.page);
    setPages(allJualsForAngsuran.data.totalPage);
  };

  const getAngsuranKe = async (noKontrak) => {
    const angsuran = await axios.post(`${tempUrl}/angsuransByNoJual`, {
      noJual: noKontrak,
      id: user._id,
      token: user.token,
      kodeCabang: user.cabang._id,
    });
    setDari(angsuran.data.tenor);
    setParentId(angsuran.data._id);

    const response = await axios.post(`${tempUrl}/angsuransChild`, {
      noJual: noKontrak,
      id: user._id,
      token: user.token,
      kodeCabang: user.cabang._id,
    });

    setNoAngsuran(response.data.angsuranKe || response.data._id);
    setTglJatuhTempoFormatted(formatDate(response.data.tglJatuhTempo));
    setTglAngAwal(
      response.data.tglJatuhTempo ? new Date(response.data.tglJatuhTempo) : null
    );
  };

  const resetEntry = () => {
    setTenorBaru("");
    setAngPerBulan("");
    setTotalPiutang(0);
  };

  const setDataLama = (item) => {
    const sisaPokok = Number(item.angModal || 0) * Number(item.sisaBulan || 0);

    setTenorLama(item.tenor || "");
    setSisaLama(item.sisaBulan || "");
    setAngPerBulanLama(formatNumber(item.angPerBulan));
    setTglAngLama(item.tglAng ? formatDate(item.tglAng) : "");
    setSisaPokokLama(formatNumber(sisaPokok));
  };

  const chooseJual = (item) => {
    if (item.isHapusBuku) {
      alert(`No. Kontrak ${item.noJual} sudah hapus buku!`);
      return;
    }

    if (rstKe === 1 && item.isRst1) {
      alert(`No. Kontrak ${item.noJual} sudah pernah RST 1!`);
      return;
    }

    if (rstKe === 2 && !item.isRst1) {
      alert(`No. Kontrak ${item.noJual} belum pernah RST 1!`);
      return;
    }

    if (rstKe === 2 && item.isRst2) {
      alert(`No. Kontrak ${item.noJual} sudah pernah RST 2!`);
      return;
    }

    setJualId(item._id);
    setNoJual(item.noJual);
    setNoKtpRegister(item.noKtpRegister);
    setNamaRegister(item.namaRegister);
    setAlmRegister(item.almRegister);
    setTanggalJual(formatDate(item.tanggalJual));
    setKodeKelurahan(
      item.kodeKelurahan
        ? `${item.kodeKelurahan.kodeKelurahan} - ${item.kodeKelurahan.namaKelurahan}`
        : ""
    );
    setKodeSurveyor(
      item.kodeSurveyor
        ? `${item.kodeSurveyor.kodeSurveyor} - ${item.kodeSurveyor.namaSurveyor}`
        : ""
    );
    setKodeMarketing(
      item.kodeMarketing
        ? `${item.kodeMarketing.kodeMarketing} - ${item.kodeMarketing.namaMarketing}`
        : ""
    );
    setTipe(item.tipe);
    setNoMesin(item.noMesin);
    setNamaWarna(item.namaWarna);
    setTahun(item.tahun);
    setDataLama(item);
    resetEntry();
    getAngsuranKe(item.noJual);
    handleCloseJual();
  };

  const saveRst = async (e) => {
    e.preventDefault();
    setValidated(true);

    const angPerBulanNumber = Number(String(angPerBulan).replace(/,/g, ""));
    const tenorNumber = Number(tenorBaru);
    const isFailedValidation =
      noJual.length === 0 ||
      !tglRst ||
      !tglAngAwal ||
      tenorNumber <= 0 ||
      angPerBulanNumber <= 0;

    if (isFailedValidation) {
      setError(true);
      setOpen(true);
      return;
    }

    const isConfirmed = window.confirm(
      `${textRst} akan mengubah data jual dan kartu angsuran, dan tidak bisa dihapus. Lanjutkan?`
    );

    if (!isConfirmed) {
      return;
    }

    const date = new Date();
    const currentDate =
      date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
    const currentTime =
      date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();

    try {
      setLoading(true);
      await axios.post(`${tempUrl}/rstTransaction`, {
        rstKe,
        idJual: jualId,
        idAngsuran: parentId,
        noJual,
        tglRst: toApiDate(tglRst),
        tenorBaru: tenorNumber,
        tglAngAwal: toApiDate(tglAngAwal),
        angPerBulan: angPerBulanNumber,
        tglUpdate: currentDate,
        jamUpdate: currentTime,
        userUpdate: user.username,
        kodeCabang: user.cabang._id,
        id: user._id,
        token: user.token,
      });

      navigate(`/daftarAngsuran/angsuran/${noJual}`);
    } catch (err) {
      if (err.response && err.response.status === 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
        return;
      }

      alert(err.response?.data?.message || "Gagal menyimpan RST");
    } finally {
      setLoading(false);
    }
  };

  const filteredJuals = juals.filter((item) => {
    if (rstKe === 1) {
      return !item.isRst1;
    }

    return item.isRst1 && !item.isRst2;
  });

  if (loading) {
    return <Loader />;
  }

  return (
    <Box>
      <Typography color="#757575">Piutang</Typography>
      <Typography variant="h4" sx={subTitleText}>
        {title}
      </Typography>
      <Typography sx={subTitleText}>
        Periode : {user.periode.namaPeriode}
      </Typography>
      <Divider sx={dividerStyle} />
      <Paper sx={contentContainer} elevation={12}>
        <Form noValidate validated={validated} onSubmit={saveRst}>
          <Paper elevation={6} sx={mainContainer}>
            <Typography variant="h5" sx={titleStyle} color="primary">
              DATA PENJUALAN
            </Typography>
            <Box sx={showDataContainer}>
              <Box sx={showDataWrapper}>
                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        No. Jual <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={noJual}
                          required
                          placeholder="Pilih..."
                          onClick={handleClickOpenJual}
                          onChange={(e) =>
                            setNoJual(e.target.value.toUpperCase())
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          No. Jual harus diisi!
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[showDataWrapper, secondWrapper]}></Box>
            </Box>
          </Paper>

          <Paper elevation={6} sx={mainContainer}>
            <Typography variant="h5" sx={titleStyle} color="primary">
              DATA PEMBELI
            </Typography>
            <Box sx={showDataContainer}>
              <Box sx={showDataWrapper}>
                <DataRow label="Nama Register" value={namaRegister} textRight={textRight} />
                <DataRow label="Alamat Rumah" value={almRegister} textRight={textRight} />
                <DataRow
                  label="No. KTP Register"
                  value={noKtpRegister}
                  textRight={textRight}
                />
                <DataRow label="Tanggal Jual" value={tanggalJual} textRight={textRight} />
              </Box>
              <Box sx={[showDataWrapper, secondWrapper]}>
                <DataRow label="Kode Kelurahan" value={kodeKelurahan} textRight={textRight} />
                <DataRow label="Kode Surveyor" value={kodeSurveyor} textRight={textRight} />
                <DataRow label="Kode Marketing" value={kodeMarketing} textRight={textRight} />
              </Box>
            </Box>
          </Paper>

          <Paper elevation={6} sx={mainContainer}>
            <Typography variant="h5" sx={titleStyle} color="primary">
              DATA MOTOR
            </Typography>
            <Box sx={showDataContainer}>
              <Box sx={showDataWrapper}>
                <DataRow label="Tipe" value={tipe} textRight={textRight} />
                <DataRow label="No. Mesin" value={noMesin} textRight={textRight} />
              </Box>
              <Box sx={[showDataWrapper, secondWrapper]}>
                <DataRow label="Nama Warna" value={namaWarna} textRight={textRight} />
                <DataRow label="Tahun Perakitan" value={tahun} textRight={textRight} />
              </Box>
            </Box>
          </Paper>

          <Paper elevation={6} sx={mainContainer}>
            <Typography variant="h5" sx={titleStyle} color="primary">
              ENTRY RST
            </Typography>
            <Box sx={showDataContainer}>
              <Box sx={showDataWrapper}>
                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Angsuran Ke- / Dari :
                      </Form.Label>
                      <Col sm={4}>
                        <Form.Control value={noAngsuran} disabled />
                      </Col>
                      <Col sm={4}>
                        <Form.Control value={dari} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <DataRow
                  label="Tgl. Jatuh Tempo"
                  value={tglJatuhTempoFormatted}
                  textRight={textRight}
                />
                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Tgl. RST <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="8">
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          minDate={new Date(user.periode.periodeAwal)}
                          maxDate={new Date(user.periode.periodeAkhir)}
                          selected={tglRst}
                          onChange={(value) => setTglRst(value)}
                          customInput={
                            <TextField
                              error={error && !tglRst}
                              helperText={error && !tglRst && "Tanggal RST harus diisi!"}
                              sx={{ width: "100%" }}
                              size="small"
                            />
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Tenor Baru <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          type="number"
                          min="1"
                          required
                          value={tenorBaru}
                          onChange={(e) => setTenorBaru(e.target.value)}
                        />
                        <Form.Control.Feedback type="invalid">
                          Tenor baru harus diisi!
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>

              <Box sx={[showDataWrapper, secondWrapper]}>
                <Box sx={oldDataCard}>
                  <Typography variant="h6" sx={oldDataTitle}>
                    Data Lama
                  </Typography>
                  <DataRow label="Tenor" value={tenorLama} textRight={textRight} />
                  <DataRow label="Sisa" value={sisaLama} textRight={textRight} />
                  <DataRow
                    label="Ang / Bln"
                    value={angPerBulanLama}
                    textRight={textRight}
                  />
                  <DataRow
                    label="Tgl. Angsuran"
                    value={tglAngLama}
                    textRight={textRight}
                  />
                  <DataRow
                    label="Sisa Pokok"
                    value={sisaPokokLama}
                    textRight={textRight}
                  />
                </Box>
                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Tgl. Ang Awal <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="8">
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          selected={tglAngAwal}
                          onChange={(value) => setTglAngAwal(value)}
                          customInput={
                            <TextField
                              error={error && !tglAngAwal}
                              helperText={
                                error && !tglAngAwal && "Tgl. Ang Awal harus diisi!"
                              }
                              sx={{ width: "100%" }}
                              size="small"
                            />
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <DataRow
                  label="Tgl. Ang Akhir"
                  value={tglAngAkhir ? formatDate(tglAngAkhir) : ""}
                  textRight={textRight}
                />
                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Ang / Bln <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={angPerBulan}
                          thousandSeparator
                          customInput={Form.Control}
                          required
                          onValueChange={(values) => {
                            setAngPerBulan(values.formattedValue);
                          }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Ang / Bln harus diisi!
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <DataRow
                  label="Total Piutang"
                  value={totalPiutang.toLocaleString("en-US")}
                  textRight={textRight}
                />
              </Box>
            </Box>
          </Paper>

          <Box sx={spacingTop}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => navigate("/daftarAngsuran")}
              sx={{ marginRight: 2 }}
            >
              {"< Kembali"}
            </Button>
            <Button variant="contained" startIcon={<SaveIcon />} onClick={saveRst}>
              Simpan
            </Button>
          </Box>
        </Form>
      </Paper>
      <Divider sx={spacingTop} />
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
      <Dialog
        open={openJual}
        onClose={handleCloseJual}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Jual`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchData}>
              <Box sx={searchBarContainer}>
                <SearchBar value={query} setSearchTerm={setQuery} />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }} className={classes.tableRightBorder}>
                      No. Jual
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }} className={classes.tableRightBorder}>
                      Nama Register
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }} className={classes.tableRightBorder}>
                      Tanggal
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }} className={classes.tableRightBorder}>
                      No. Plat
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Alamat</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredJuals.map((item) => (
                    <TableRow
                      key={item._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={() => chooseJual(item)}
                    >
                      <TableCell component="th" scope="row">
                        {item.noJual}
                      </TableCell>
                      <TableCell>{item.namaRegister}</TableCell>
                      <TableCell>{item.tanggalJualFormatted}</TableCell>
                      <TableCell>{item.nopol}</TableCell>
                      <TableCell>{item.almRegister}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pages}
                page={page + 1}
                onChange={handleChange}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

const DataRow = ({ label, value, textRight }) => (
  <Row>
    <Col>
      <Form.Group as={Row} className="mb-3">
        <Form.Label column sm="4" style={textRight}>
          {label} :
        </Form.Label>
        <Col sm="8">
          <Form.Control value={value} disabled />
        </Col>
      </Form.Group>
    </Col>
  </Row>
);

export default TambahRst;

const subTitleText = {
  fontWeight: "900",
};

const dividerStyle = {
  mt: 2,
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const contentContainer = {
  p: {
    sm: 0,
    md: 3,
  },
  pt: {
    sm: 0,
    md: 1,
  },
  mt: {
    sm: 0,
    md: 2,
  },
  backgroundColor: Colors.grey100,
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const mainContainer = {
  padding: 3,
  borderRadius: "20px",
  margin: {
    sm: 0,
    md: 4,
  },
  marginTop: {
    xs: 4,
    md: 0,
  },
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const titleStyle = {
  textAlign: "center",
  fontWeight: "600",
};

const oldDataCard = {
  border: `1px solid ${Colors.grey300}`,
  borderRadius: "8px",
  padding: 2,
  marginBottom: 3,
  backgroundColor: "white",
};

const oldDataTitle = {
  fontWeight: "600",
  marginBottom: 2,
  color: Colors.blue700,
};

const colorRed = {
  color: "red",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};
